export const processDataIuran = (iuran) => {
  const dataIuran = iuran.data.kode.split('#')

  const dataIuranParsed = dataIuran.map(iuran => {
    let data = iuran.split('=')
    return {
      [data[0]]: data[1]
    }
  })

  const dataIuranReduced = dataIuranParsed.reduce((obj, iuran) => {
    const key = Object.keys(iuran)[0]
    return {
      ...obj,
      [key]: iuran[key]
    }
  }, {})

  return dataIuranReduced
}

export const composeIuran = (jht, period) => {
  const program = `JHT=${jht === 'true' ? 'Y':'N'}:${period}#JKK=Y:${period}#JKM=Y:${period}`
  return program
}

export const moneyFormat = (str) => {
  const num = parseInt(str).toLocaleString('de-DE')
  return num
}


// WEBPACK FOOTER //
// ./src/lib/iuran.js